var _circle, _path, _path2, _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPpidCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9993,
    cy: 27.4348,
    r: 27.4348,
    fill: "#E8F0F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1202 22.9613V36.4949C39.1202 37.3795 38.7688 38.228 38.1432 38.8535C37.5177 39.4791 36.6693 39.8305 35.7846 39.8305H20.2184C19.3338 39.8305 18.4853 39.4791 17.8598 38.8535C17.2342 38.228 16.8828 37.3795 16.8828 36.4949V14.2575C16.8828 13.3728 17.2342 12.5244 17.8598 11.8989C18.4853 11.2733 19.3338 10.9219 20.2184 10.9219H27.0807C27.6703 10.922 28.2357 11.1562 28.6526 11.573L38.4691 21.3894C38.8859 21.8064 39.1201 22.3718 39.1202 22.9613Z",
    stroke: "#39A3D6",
    strokeWidth: 1.71468,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.002 11.4766V19.8156C28.002 20.4054 28.2362 20.971 28.6533 21.388C29.0703 21.805 29.6359 22.0393 30.2257 22.0393H38.5647",
    stroke: "#39A3D6",
    strokeWidth: 1.71468,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1866_5920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6452 27.9297L26.9197 34.4987L24.5681 32.1472M24.3381 34.5243L21.9609 32.1472M30.0381 27.9297L26.7919 31.6615",
    stroke: "#39A3D6",
    strokeWidth: 1.37174,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1866_5920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.087,
    height: 13.087,
    fill: "white",
    transform: "translate(21.7598 23.6875)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpidCheck);
export default __webpack_public_path__ + "static/media/ppid-check.f5b10337bdd2ca8561119a1755a40e05.svg";
export { ForwardRef as ReactComponent };